/**
 * Talala API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GetPromocode404Response { 
    error_key?: GetPromocode404Response.ErrorKeyEnum;
}
export namespace GetPromocode404Response {
    export type ErrorKeyEnum = 'promocode.not_found' | 'offer.not_found';
    export const ErrorKeyEnum = {
        PromocodeNotFound: 'promocode.not_found' as ErrorKeyEnum,
        OfferNotFound: 'offer.not_found' as ErrorKeyEnum
    };
}


